import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../services/store';
import { SettingsState } from '../types/settings';

const initialState: SettingsState = {
  shareLinkNotification: {
    list: [],
    page: 0,
    sortDir: 'DESC',
  },
  registrationReq: {
    list: [],
    page: 0,
    sortBy: 'request_date',
    sortDir: 'DESC',
  },
  feedback: {
    page: 0,
  },
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    shareLinkListChanged: (state, { payload }) => {
      state.shareLinkNotification.list = payload;
    },
    shareLinkListRemoved: (state, { payload }) => {
      state.shareLinkNotification.list =
        state.shareLinkNotification.list.filter(
          ({ projectId }) => projectId !== payload
        );
    },
    shareLinkPageChanged: (state, { payload }) => {
      state.shareLinkNotification.page = payload;
    },
    shareLinkSortDirChanged: (state, { payload }) => {
      state.shareLinkNotification.sortDir = payload;
    },
    reqListChanged: (state, { payload }) => {
      state.registrationReq.list = payload;
    },
    reqListUpdated: (state, { payload }) => {
      const updatedList = state.registrationReq.list.map((item) =>
        item.seq === payload ? { ...item, status: 1 as 1 } : item
      );
      state.registrationReq.list = updatedList;
    },
    reqListRemoved: (state, { payload }) => {
      state.registrationReq.list = state.registrationReq.list.filter(
        ({ seq }) => seq !== payload
      );
    },
    reqPageChanged: (state, { payload }) => {
      state.registrationReq.page = payload;
    },
    reqSortDirChanged: (state, { payload }) => {
      state.registrationReq.sortDir = payload;
    },
    feedbackPageChanged: (state, { payload }) => {
      state.feedback.page = payload;
    },
  },
});

export const {
  shareLinkListChanged,
  shareLinkListRemoved,
  shareLinkPageChanged,
  shareLinkSortDirChanged,
  reqListChanged,
  reqListUpdated,
  reqListRemoved,
  reqPageChanged,
  reqSortDirChanged,
  feedbackPageChanged,
} = settingsSlice.actions;

export const selectShareLinkList = (state: RootState) =>
  state.settings.shareLinkNotification.list;

export const selectShareLinkPage = (state: RootState) =>
  state.settings.shareLinkNotification.page;

export const selectShareLinkSortDir = (state: RootState) =>
  state.settings.shareLinkNotification.sortDir;

export const selectReqList = (state: RootState) =>
  state.settings.registrationReq.list;

export const selectReqPage = (state: RootState) =>
  state.settings.registrationReq.page;

export const selectReqSortDir = (state: RootState) =>
  state.settings.registrationReq.sortDir;

export const selectFeedbackPage = (state: RootState) =>
  state.settings.feedback.page;

export default settingsSlice.reducer;
